<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div :class="['experience-section-skeleton', { _mobile: isMobile }]">
    <div v-for="item in 2" :key="item" class="experience-section-skeleton__content">
      <Skeleton :width="isMobile ? '215px' : '310px'" height="60px" />
      <Skeleton width="100%" :height="isMobile ? '168px' : '351px'" />
    </div>
  </div>
</template>

<style lang="less" scoped>
.experience-section-skeleton {
  .flex-column(48px);
  .box-shadow();

  padding: @size-x8;

  &__content {
    .flex-column(@size-x8);
  }

  &._mobile {
    gap: @size-x10;
    padding: @size-x5;
  }

  &._mobile &__content {
    gap: @size-x5;
  }
}
</style>
